import * as types from '../mutation-types'

const state = {
    clients: '',
}
const getters = {
    selectedClientId: state => state.clients.id


}
const actions = {
    setClient({
        commit,
        state
    }, data) {
        commit(types.SET_SELECTED_CLIENT, data);
    }
}
const mutations = {
  [types.SET_SELECTED_CLIENT](state, data) {
        state.clients = data;
        //console.log(state.employers);
        //console.log("DATA", state.employers);
    }
}
export default {
    state,
    getters,
    actions,
    mutations
}
